import { Text } from '@mantine/core'

interface IProps {
  size?: number
}

export const RequiredIcon = ({ size = 16 }: IProps) => {
  return <Text style={{ marginRight: '2px', fontSize: size + 'px', color: '#e26247' }}>*</Text>
}
